import PackageSalesModule from "./packagesSalesModule";
import PackageSalesSagas from "./redux/packagesSalesSaga";
import PackageSalesReducer from "./redux/packagesSalesReducer";

export default {
  Component: PackageSalesModule,
  moduleName: "packagesSales",
  saga: PackageSalesSagas(),
  reducer: PackageSalesReducer
};
